export default "__VITE_ASSET__D9sSgb9F__"